function equalizePromo(hasFourthCol){
	var winWidth = $(window).width(),
		$promo = $('.promo-row').find('.promo'),
		$promoTitle = $('.promo-row').find('.promo-title'),
		$promoImage = $('.promo-row').find('.promo-img');

	/* add extra class for ie8 users to alternate the position of the text and image */
	if ($('html').hasClass('lt-ie9')) {
		$('.promo-row > .promo:even').addClass('even');
	}

	/* Picture - set min-height on promo-img to allow for better height measurements when the image has not loaded yet */
	$promoImage.each(function () {
		var $imgWrapper = $(this),
		    imgWidth = $imgWrapper.width();
		$imgWrapper.css('min-height',imgWidth);
	});

	/* Title */
	if (winWidth < 640) {
		$promoTitle.each(function () {
			var $h2 = $(this).find('h2');
			var h2Height = $h2.height();
			var imgHeight = $h2.closest('.promo-box').find('.promo-img').height();
			var offset = (imgHeight - h2Height) / 2;
			$h2.css({'padding-top':offset,'padding-bottom':offset});
		});
	} else {
		var maxTitleHeight = 0;
		/* find the tallest h2 */
		$promoTitle.each(function () {
			var h2Height = $(this).find('h2').height();
			if (h2Height > maxTitleHeight) {
				maxTitleHeight = h2Height;
			}
		});
		/* adjust the padding for each h2 to match tallest title */
		$promoTitle.each(function () {
			var $h2 = $(this).find('h2');
			var h2Height = $h2.height();
			var offset = (maxTitleHeight - h2Height) / 2;
			$h2.css({'padding-top':offset,'padding-bottom':offset});
		});
	}

	if (hasFourthCol) {
		var $specialOffersBtn = $('#promo-block').find('.special-offers-button'),
			specialOfferOffset = 10,
			$bookedPassengers = $('#promo-block').find('.booked-passengers'),
			padSpacing = 15;
		
		if ($('html').hasClass('lt-ie9')) {
			padSpacing = 30;
		}

		if (localeData != undefined && localeData.specialOffers == 'true') {
			$specialOffersBtn.parent().addClass('show-so-btn');
		} else {
			$specialOffersBtn.parent().removeClass('show-so-btn');
		}

		
		var specialOffersHeight = $specialOffersBtn.height();

		if (winWidth > 767) {
			/* adjust padding on special offers button to align with titles */
			if (maxTitleHeight > specialOffersHeight) {
				specialOfferOffset = (maxTitleHeight + 20 - specialOffersHeight) / 2;
			}
		} else if (winWidth > 639) {
			/* adjust padding on special offers button to align with booked guests */
			specialOfferOffset = ($bookedPassengers.outerHeight() - specialOffersHeight) / 2;
		}

		$specialOffersBtn.css({'padding-top':specialOfferOffset,'padding-bottom':specialOfferOffset});
		

		/* Booked Passengers */
		if (winWidth > 767) {
			/* adjust the booked passengers min-height when in 4 column layout */
			if ($specialOffersBtn.parent().hasClass('show-so-btn')) {
				minHeight = $promo.height() - ($specialOffersBtn.outerHeight(true) + padSpacing);
			} else {
				minHeight = $promo.height();
			}
			$bookedPassengers.css('min-height', minHeight)
		} else {
			/* remove min-height */
			$bookedPassengers.css('min-height', 0 );
		}
	}
}

